import request from '@/utils/request'

/**
 * @description APIGet
 */
export function APIGet(sendUrl, data) {
  return request({
    url: '/front/' + sendUrl,
    method: 'get',
    params: data
  })
}

/**
 * @description APIPost
 */
export function APIPost(sendUrl, params) {
  return request({
    url: '/front/' + sendUrl,
    method: 'post',
    data: params
  })
}

/**
 * 导航数据 列表
 * @param pram
 */
export function categoryList(params) {
  return request({
    url: '/front/comcode/getList',
    method: 'post',
    data: params
  })
}

/**
 * 文章数据 列表
 * @param pram
 */
export function pageList(params) {
  return request({
    url: '/front/comcode/page',
    method: 'post',
    data: params
  })
}

/**
 * 文章详细
 * @param pram
 */
export function getDetail(params) {
  return request({
    url: '/front/comcode/getData',
    method: 'post',
    data: params
  })
}

/**
 * 文章详细
 * @param pram
 */
export function customer(params) {
  return request({
    url: '/front/customer/save',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js